<template>
  <div>
    <div class="alert alert-primary" role="alert">
      <div class="alert-body">
        <div class="text-center">
          <h1 class="display-4">Welcome</h1>
          <p>My favorite relatives, my world is wonderful because of you</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCard, BCardText, BLink, BAlert } from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BAlert,
  },
};
</script>

<style>
</style>
